<template>
  <div>
    <Form :model="searchCondition" inline :label-width="60">
      <FormItem label="商品类型">
        <EnumSelect
          type="IntegralGoodsType"
          selector="select"
          v-model="searchCondition.goods_type"
          clearable
          style="width:200px"
        ></EnumSelect>
      </FormItem>
      <FormItem label="订单状态">
        <EnumSelect
          type="IntegralExchangeStatus"
          selector="select"
          v-model="searchCondition.status"
          clearable
          style="width:200px"
        ></EnumSelect>
      </FormItem>
      <FormItem label="下单时间">
        <Date-picker
          ref="datePicker"
          type="datetimerange"
          placeholder="开始时间 — 结束时间"
          @on-change="onDateRange"
          style="width:280px;"
          :editable="false"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Date-picker>
      </FormItem>
      <FormItem label="商品名称">
        <Input
          v-model="searchCondition.shop_name"
          placeholder="请输入商品名称关键字"
          class="com-width"
          @keydown.native.prevent.enter="onSearch"
          clearable
          style="width:200px"
        ></Input>
      </FormItem>
      <FormItem label="订单编号">
        <Input
          v-model="searchCondition.order_number"
          placeholder="请输入订单编号关键字"
          class="com-width"
          @keydown.native.prevent.enter="onSearch"
          clearable
          style="width:200px"
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入兑换人手机号"
          class="com-width"
          @keydown.native.prevent.enter="onSearch"
          clearable
          style="width:200px"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onShip" class="btn-margin-right">批量导出</Button>
      <Button type="primary" @click="onExport" class="btn-margin-right">批量导出</Button>
      <Button type="primary" @click="onWatch" class="btn-margin-right">查看报表</Button>
    </div>
    <div class="content">
      <mix-grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/integral/exchange/index"
        :search="searchCondition"
        method="post"
        :rowsFormatter="onRowsFormatter"
      >
        <template slot-scope="{ row }" slot="price">
          <span>{{row.exchange_price+"*"+row.product_number}}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div class="table-btn-box">
            <Button type="text" size="small" @click="onDetail(row)">订单详情</Button>
            <Button
              v-if="row.ship_status == 1"
              type="text"
              size="small"
              @click="onDelivery(row)"
            >-发货</Button>
          </div>
        </template>
      </mix-grid>
    </div>
    <exports-modal
      title="导出兑换记录"
      :type="9"
      :params="searchCondition"
      v-model="showExportModal"
      @onSuccess="onWatch"
    ></exports-modal>
    <Modal class="delivery-dlg" v-model="deliveryDlg.show" title="填写发货单">
      <Form ref="form" :model="form" :rules="rules" :label-width="100">
        <FormItem label="订单编号">{{ deliveryDlg.data.order_number }}</FormItem>
        <FormItem label="快递公司" prop="logistics_name">
          <Select v-model="form.logistics_name">
            <Option v-for="item in shippers" :label="item" :value="item"></Option>
          </Select>
        </FormItem>
        <FormItem label="快递单号" prop="logistics_no">
          <Input v-model="form.logistics_no" type="text" placeholder="请输入快递单号" :maxlength="50"></Input>
        </FormItem>
        <FormItem label="发货说明" prop="remark">
          <Input
            v-model="form.remark"
            type="textarea"
            placeholder="请输入发货说明"
            :rows="3"
            :maxlength="500"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align:center;">
        <Button type="primary" @click="onOk" size="large" style="width:100px;">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import ExportsModal from "@/components/ExportsModal";
export default {
  name: "IntegralExchange",
  components: { ExportsModal },
  data() {
    return {
      shippers: [],
      searchCondition: {
        goods_type: "",
        status: "",
        shop_name: "",
        order_number: "",
        mobile: "",
        start_time: "",
        end_time: ""
      },
      tableColumns: [
        {
          title: "订单编号",
          key: "order_number",
          mix: true
        },
        {
          title: "下单时间",
          key: "created_at",
          mix: true
        },
        {
          title: "商品名称",
          key: "name",
          align: "center",
          minWidth: 300
        },
        {
          title: "单价（积分）/ 数量",
          slot: "price",
          align: "center",
          minWidth: 120
        },
        {
          title: "订单状态",
          key: "order_status_name",
          align: "center",
          minWidth: 100
        },
        {
          title: "兑换人",
          key: "nickname",
          align: "center",
          minWidth: 100
        },
        {
          title: "兑换人手机号",
          key: "mobile",
          align: "center",
          minWidth: 120
        },
        {
          title: "实付（积分）",
          key: "exchange_price",
          align: "center",
          minWidth: 100
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100
        }
      ],
      showExportModal: false,
      deliveryDlg: {
        show: false,
        data: {}
      },
      form: {
        logistics_name: "",
        logistics_no: "",
        remark: ""
      },
      rules: {
        logistics_name: [
          { required: true, message: "请输入快递公司", trigger: "blur" }
        ],
        logistics_no: [
          { required: true, message: "请输入快递单号", trigger: "blur" }
        ],
        remark: [{ required: true, message: "请输入发货说明", trigger: "blur" }]
      }
    };
  },
  created() {
    this.requestShipCompony();
  },
  methods: {
    requestShipCompony() {
      this.$http.get(
        "/api/ship/shippers").then(res=>{
          this.shippers = res
        });
    },
    onDateRange(range) {
      this.searchCondition.start_time = range[0];
      this.searchCondition.end_time = range[1];
    },
    onSearch(reset = true) {
      if (this.searchCondition.status === undefined) {
        this.searchCondition.status = "";
      }
      if (this.searchCondition.goods_type === undefined) {
        this.searchCondition.goods_type = "";
      }
      this.$refs.grid.refresh(reset);
    },
    onReset() {
      this.$pub.clearObj(this.searchCondition);
      this.$refs.datePicker.handleClear();
      this.onSearch();
    },
    onRowsFormatter(rows) {
      rows.forEach(i => {
        if (i.shop_type == 12) {
          if (i.ship_status == 1) {
            i.order_status_name = "待发货";
          } else if (i.ship_status == 3) {
            i.order_status_name = "已发货";
          }
        }
        if (!i.order_status_name) {
          if (i.order_status == 2) {
            i.order_status_name = "已完成";
          }
        }
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    },
    onExport() {
      this.showExportModal = true;
    },
    onShip() {
      this.$router.push({ name: "OrderShipImports", query: { type: "ship" } });
    },
    onWatch() {
      this.$router.push({
        name: "Exports",
        query: {
          type: "integral"
        }
      });
    },
    onDelivery(row) {
      this.form.logistics_name = "";
      this.form.logistics_no = "";
      this.form.remark = "";
      this.deliveryDlg.show = true;
      this.deliveryDlg.data = row;
    },
    onOk() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        await this.$http.get(
          "/api/integral/exchange/delivery/" + this.deliveryDlg.data.id,
          this.form
        );
        this.deliveryDlg.show = false;
        this.$Message.success("发货成功");
        this.$refs.grid.refresh();
      });
    },
    onDetail(row) {
      this.$router.push({
        name: "IntegralExchangeDetail",
        query: {
          id: row.id
        }
      });
    }
  }
};
</script>
